import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    console.log('request: ', request);
    
    const modifiedRequest = request.clone({
      //remove headers for file upload so browser can determine proper content type
      headers: request.headers.get('multi')
        ? request.headers.delete('Content-Type')
        : request.headers,
    });

    return next.handle(modifiedRequest);
  }
}
